import { degreesToRadians, radiansToDegrees } from './utils';
export const getCirclePoint = (degrees, center, radius) => {
    const angle = degreesToRadians(degrees);
    const x = center.x + radius * Math.sin(angle);
    const y = center.y - radius * Math.cos(angle);
    return { x, y };
};
export const getDegreesBetweenPoints = (a, angleCorner, c) => {
    const ba = { x: a.x - angleCorner.x, y: a.y - angleCorner.y };
    const bc = { x: c.x - angleCorner.x, y: c.y - angleCorner.y };
    const dotProduct = ba.x * bc.x + ba.y * bc.y;
    const magnitudeBA = Math.sqrt(ba.x * ba.x + ba.y * ba.y);
    const magnitudeBC = Math.sqrt(bc.x * bc.x + bc.y * bc.y);
    const cosTheta = dotProduct / (magnitudeBA * magnitudeBC);
    const angleRadians = Math.acos(cosTheta);
    const angleDegrees = radiansToDegrees(angleRadians);
    return angleDegrees;
};
export const getCircleIntersections = (circles) => {
    const dx = circles[1].center.x - circles[0].center.x;
    const dy = circles[1].center.y - circles[0].center.y;
    const dist = Math.hypot(dy, dx);
    if (dist > circles[0].radius + circles[1].radius) {
        return [];
    }
    if (dist < Math.abs(circles[0].radius - circles[1].radius)) {
        return [];
    }
    if (circles[0].center.x === circles[1].center.x &&
        circles[0].center.y === circles[1].center.y &&
        circles[0].radius === circles[1].radius) {
        throw new Error('Comparing two equivalent circles');
    }
    const centroid = (Math.pow(circles[0].radius, 2) - Math.pow(circles[1].radius, 2) + Math.pow(dist, 2)) / (2 * dist);
    const x2 = circles[0].center.x + (dx * centroid) / dist;
    const y2 = circles[0].center.y + (dy * centroid) / dist;
    const h = Math.sqrt(Math.pow(circles[0].radius, 2) - Math.pow(centroid, 2));
    const rx = -dy * (h / dist);
    const ry = dx * (h / dist);
    const pointA = {
        x: Number((x2 + rx).toFixed(15)),
        y: Number((y2 + ry).toFixed(15)),
    };
    const pointB = {
        x: Number((x2 - rx).toFixed(15)),
        y: Number((y2 - ry).toFixed(15)),
    };
    const result = [pointA];
    if (pointB.x !== pointA.x || pointB.y !== pointA.y) {
        result.push(pointB);
    }
    return result;
};
//# sourceMappingURL=geometry.js.map